export const input = ({ theme: { dimensions } }) => ({
    position: 'relative',
    marginTop: dimensions.inputRowGap,
    marginBottom: dimensions.inputRowGap,
});
